import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import escapeStringRegexp from 'escape-string-regexp';
import Box from '@rexlabs/box';
import { useStyles, StyleSheet, text } from '@rexlabs/styling';
import { useSelect } from '../../hooks/use-select';
var defaultStyles = StyleSheet({
  label: _objectSpread({
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap'
  }, text.styles({
    target: 'select.option.label',
    fallback: 'normal.default',
    color: function color(_ref) {
      var token = _ref.token;
      return token('color.textStyle.body.subtext');
    }
  })),
  highlighted: _objectSpread({}, text.styles({
    target: 'select.option.label.highlighted',
    color: function color(_ref2) {
      var token = _ref2.token;
      return token('color.textStyle.body.default');
    }
  }))
});
export function HighlightedLabel(_ref3) {
  var children = _ref3.children;
  var s = useStyles(defaultStyles);

  var _useSelect = useSelect(),
      filterInputValue = _useSelect.filterInputValue;

  var textToHighlight = filterInputValue;
  var label = textToHighlight.length > 0 ? children.split(new RegExp("(".concat(escapeStringRegexp(textToHighlight), ")"), 'i')) : [children];
  return /*#__PURE__*/React.createElement(Box, null, _mapInstanceProperty(label).call(label, function (part, index) {
    return /*#__PURE__*/React.createElement("span", _extends({}, s('label', {
      highlighted: label.length === 1 || part.toLowerCase() === textToHighlight.toLowerCase()
    }), {
      key: index
    }), part);
  }));
}